import ProductSlider from "../lib/slider/product-slider";
import Page from "../common/page";
import Accordion from "../lib/accordion";
import {CustomEventHandler} from "../utils/CustomEventHandler";

export default class PageProductDetail extends Page {
    setPage() {
        const productName = this.el.getAttribute('data-product-name');
        const sliderData = this.data.page.data[productName];

        if (sliderData) {
			if (this.el.querySelector('.sec-slider')) {
				new ProductSlider(this.el.querySelector('.sec-slider'), sliderData);
			}
        } else {
			if (this.el.querySelector('.sec-slider')) {
            this.el.querySelector('.sec-slider').style.display = 'none';
			}
        }

        this.accordianEl = this.el.querySelector('.accordion-container');
        this.accordianContentEl = this.el.querySelector('.accordion-container .txt-holder');
        this.accordianBtnEl = this.el.querySelector('.accordion-container button');

        CustomEventHandler.addHandler(this.accordianEl, 'click', ()=>this.onToggleAccordianHandler());
    }

    onToggleAccordianHandler() {
        if (this.accordianContentEl.classList.contains('onShow')) {
            this.accordianContentEl.classList.remove('onShow');
            this.accordianBtnEl.style.transform = 'rotate(0)';
        } else {
            this.accordianContentEl.classList.add('onShow');
            this.accordianBtnEl.style.transform = 'rotate(180deg)';
        }
        window.dispatchEvent(CustomEventHandler.polyfillEvent('resize'));
    }
}
